import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_ENTERPRISE = 'UPDATE_ENTERPRISE';
export const UPDATE_ENTERPRISE_SUCCESS = 'UPDATE_ENTERPRISE_SUCCESS';
export const UPDATE_ENTERPRISE_FAILURE = 'UPDATE_ENTERPRISE_FAILURE';

// Action Creators
export const updateEnterprise = () => ({
  type: UPDATE_ENTERPRISE,
});

export const updateEnterpriseSuccess = (users) => ({
  type: UPDATE_ENTERPRISE_SUCCESS,
  payload: users,
});

export const updateEnterpriseFailure = (error) => ({
  type: UPDATE_ENTERPRISE_FAILURE,
  payload: error,
});

// Thunk Function
export const updateEnterpriseCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(updateEnterprise());
    try {
      const response = await putMethodWithToken(
        url?.particularEnterprise + data?.id + '/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateEnterpriseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateEnterpriseFailure('error?.message'));
      }
    } catch (error) {
      dispatch(updateEnterpriseFailure(error?.message));
    }
  };
};
